
import React, { useEffect, useState } from 'react'
import { Dropdown, Grid, Icon, Rail } from 'semantic-ui-react'
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash'
import { useTranslation } from 'react-i18next';

import { SetPropertyType } from "../../../../redux/actions/mainActions"
import "./SearchPropertyType.css"

const SearchPropertyType = ({ activeItem,setActiveItem }) => {
  const { t } = useTranslation()

  const dispatch = useDispatch()
  const source = [
    { key: 1, text: 'ویلا', value: 'ویلا' },
    { key: 2, text: 'آپارتمان', value: 'آپارتمان' },
    { key: 3, text: 'مغازه', value: 'مغازه' },
    { key: 4, text: 'ویلا', value: 'ویلا' },
    { key: 5, text: 'آپارتمان', value: 'آپارتمان' }
  ]



  const propertyType = useSelector((state) => state.main.propertyType)




  const handleSearchChange = (e, { value }) => {
    dispatch(SetPropertyType(value))
    setActiveItem("")

  }



  return <Grid centered verticalAlign="middle" >


    <Grid.Column width={16}>

      <Dropdown
        open={activeItem == "property-type"}
        icon="none"
        placeholder={t("home:ChooseAnOption")}
        fluid
        search
        selection
        //clearable
        options={source}
        className="search-property-type"
        onChange={(e, data) => handleSearchChange(e, data)}
        onFocus={()=>setActiveItem( "property-type")}
        value={propertyType}
      />

    </Grid.Column>
  </Grid>
}
export default SearchPropertyType
